import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

/**
 * Agent flight proposal (flights_new / flight-only): normalized package + LDS slice.
 * @param {string|number} dynamicPackageId
 * @param {string|number} agentID
 * @param {{ isAdmin?: boolean }} [opts]
 */
export async function fetchFlightProposal(dynamicPackageId, agentID, opts = {}) {
  const params = { agentID: String(agentID) };
  if (opts.isAdmin) params.isAdmin = "true";
  const { data } = await axios.get(
    `${resolveApiUrl("/api/flight-proposals")}/${dynamicPackageId}`,
    { params, withCredentials: true }
  );
  return data;
}

/**
 * POST PROPOSAL to LDS (send_lds_proposal, force_retry, DB persist via execute_lds_reservation).
 */
export async function sendFlightProposalToSupplier(dynamicPackageId, agentID, opts = {}) {
  const { data } = await axios.post(
    `${resolveApiUrl("/api/flight-proposals")}/${dynamicPackageId}/send-to-supplier`,
    { agentID, isAdmin: opts.isAdmin },
    { withCredentials: true }
  );
  return data;
}
